<template>
  <div class="w-full">
    <div class="vx-row">
      <div class="vx-col w-3/4">
        <label>{{ label }} {{ !isEmpty ? ` ${this.month}/${this.day}/${this.year}` : null }}</label>
      </div>
      <div class="vx-col w-1/4 text-right">
        <label @click="reset" class="text-reset"> {{$t('clear')}} </label>
        <!-- <vs-button color="success" type="flat" icon-pack="feather" icon="icon-check" size="small"></vs-button> -->
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col xs:w-1/3 sm:w-1/3 w-full mb-1">
        <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
          <div class="vs-con-input">
            <input
              name="month"
              placeholder="MM"
              class="w-full vs-inputx vs-input--input normal hasValue"
              v-model="month"
              type="number"
              min="1"
              max="12"
              v-mask="'##'"
              ref="month"
              @keyup="onKeyPrees('month')"
              @change="validate('month')"
              :disabled="disabled"
            />
          </div>
          <!-- @keyup="validate('month')" -->
        </div>
      </div>
      <div class="vx-col xs:w-1/3 sm:w-1/3 w-full mb-1">
        <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
          <div class="vs-con-input">
            <input
              name="day"
              placeholder="DD"
              class="w-full vs-inputx vs-input--input normal hasValue"
              v-model="day"
              type="number"
              min="1"
              max="31"
              v-mask="'##'"
              ref="day"
              @keyup="onKeyPrees('day')"
              @change="validate('day')"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>
      <div class="vx-col xs:w-1/3 sm:w-1/3 w-full mb-1">
        <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
          <div class="vs-con-input">
            <input
              name="year"
              placeholder="YYYY"
              class="w-full vs-inputx vs-input--input normal hasValue"
              v-model="year"
              min="1"
              max="9999"
              type="number"
              v-mask="'####'"
              ref="year"
              @change="validate('year')"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="vx-row mb-6" v-show="!isEmpty">
      <div class="vx-col w-full">
        <span class="text-danger text-sm" v-show="!isValid" > {{ errorMsg }} </span>
      </div>
    </div>-->
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    label: {
      default: "Date",
    },
    value: {
      type: String,
      default:''//moment().format('Y-MM-D')
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    onlyNewerYear: {
      default: true,
      type: Boolean,
    }
  },
  data: function () {
    return {
      // errorMsg:'This date is invalid',
      year: "",
      month: "",
      day: "",
    };
  },
  computed: {
    date: function () {
      return `${this.year}-${this.month}-${this.day}`;
    },
    isEmpty: function () {
      return this.year === "" && this.month === "" && this.day === "";
    },
    currentYear(){
      return moment().format('YYYY')
    }
  },
  watch: {
    value: function () {
      this.init();
    },
  },
  created: function () {
    this.init();
  },
  methods: {
    init: function () {
      if (this.value !== null) {
        let fullDate = this.value.split("-");
        this.year = fullDate[0] !== undefined ? fullDate[0] : "";
        this.month = fullDate[1] !== undefined ? fullDate[1] : "";
        this.day = fullDate[2] !== undefined ? fullDate[2] : "";
      }
    },
    updateDate: function () {
      this.$emit("input", this.isEmpty ? null : this.date);
    },
    setFocus: function (current, next, length) {
      if (this[current].length >= length) {
        this.$refs[next].focus();
      }
    },
    onKeyPrees:function(input){
      if(input == 'month'){
        this.setFocus('month','day',2)
      }
      if(input == 'day'){
        this.setFocus('day','year',2)
      }
    },
    validate: function (input) {
      if(input==='month'){
        if(this.month < 1){
          this.month = 1
        }
        if(this.month > 12 ){
          this.month = 12
        }
        this.updateDate()
        return
      }
      if(input==='day'){
        if(this.day < 1){
            this.day = 1
        }
        if(this.day > 31 ){
          this.day = 31
        }
        if(this.month == 2){
          if(this.day > 29 ){
            this.day = 29
          }
        }
        this.updateDate()
        return
      }
      if(input==='year'){
        if(this.year > 9999 ){
          this.year = 9999
        }
        /* if(this.onlyNewerYear == true && this.year < parseInt(this.currentYear)){
            this.year = parseInt(this.currentYear)
        } */
        this.updateDate()
        return
      }
      
    },
    reset(){
      this.$emit('input', '');
    }
  },
};
</script>

<style>
.text-reset{
  color:#BC1300;
  cursor: pointer;
}
</style>